import React, { useEffect, useState } from "react";
import ProductCard from "../catalog/components/ProductCard";
import { sortProductsAlphanumeric } from "@shared/lib";

interface Product {
  id: number;
  name: string;
  images: { src: string }[];
}

interface ProductGridProps {
  currentPage: number;
  categoryId: number | null;
  onTotalItemsChange: (total: number) => void;
}

const ProductGrid: React.FC<ProductGridProps> = ({ currentPage, categoryId, onTotalItemsChange }) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const API_URL = "https://huter.diy/wordpress/wp-json/wc/v3/products";
  const API_KEY = "ck_b633c1877cf1de3bdbb01117e1fa8215b9b99e43";
  const API_SECRET = "cs_5c69080f905a13fda5aefffb41f6ac3988ab6478";

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams({
          page: currentPage.toString(),
          per_page: "12",
          consumer_key: API_KEY,
          consumer_secret: API_SECRET,
        });

        if (categoryId) {
          params.append("category", categoryId.toString());
        }

        const searchParams = new URLSearchParams(window.location.search);
        const searchQuery = searchParams.get('q');
        if (searchQuery) {
          params.append("search", searchQuery);
        }

        const response = await fetch(`${API_URL}?${params.toString()}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (!Array.isArray(data)) {
          throw new Error('Invalid response format');
        }

        // Применяем алфавитно-цифровую сортировку к товарам
        const sortedProducts = sortProductsAlphanumeric(data);
        setProducts(sortedProducts);

        const totalItems = response.headers.get("x-wp-total");
        if (totalItems) {
          onTotalItemsChange(parseInt(totalItems, 10));
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        setError("Ошибка загрузки товаров. Попробуйте позже.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [currentPage, categoryId, window.location.search, onTotalItemsChange]);

  return (
    <div className="grid mb-10 grid-cols-[repeat(3,1fr)] max-md:grid-cols-[repeat(2,1fr)] max-sm:grid-cols-[1fr] max-w-[939px] mx-auto w-full justify-items-center">
      {loading ? (
        <div className="col-span-3 text-center text-xl font-bold">Loading...</div>
      ) : error ? (
        <div className="col-span-3 text-center text-xl font-bold text-red-500">{error}</div>
      ) : products.length > 0 ? (
        products.map((product) => (
          <ProductCard 
            key={product.id} 
            id={product.id} 
            image={product.images[0]?.src || "/placeholder.jpg"} 
            title={product.name} 
          />
        ))
      ) : (
        <div className="col-span-3 text-center text-xl font-bold">Products not found</div>
      )}
    </div>
  );
};

export default ProductGrid;